export default {
  jobs: {
    title: 'Job Recruitment',
    searchPlaceholder: 'Search jobs',
    viewDetails: 'View Details',
    loading: 'Loading...',
    empty: 'No job information available',
    jobDetails: 'Job Details',
    location: 'Location: ',
    publishTime: 'Publish Time: ',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    education: 'Education',
    resume: 'Resume',
    availableDate: 'Available Date',
    selectAvailableDate: 'Please select available date',
    selfIntroduction: 'Self Introduction',
    selfIntroductionPlaceholder: 'Please briefly introduce yourself',
    uploadTip: 'Drag file here or click to upload',
    resumeFormatTip: 'Support PDF, Word format, file size not exceed 5MB',
    applyForJob: 'Apply for Job',
    applyTable: 'Application Table',
    form: {
      namePlaceholder: 'Please enter your name',
      emailPlaceholder: 'Please enter your email',
      phonePlaceholder: 'Please enter your phone',
      educationPlaceholder: 'Please enter your education',
      submitting: 'Submitting...'
    },
    success: {
      submitSuccess: 'Application submitted successfully',
      uploadSuccess: 'Upload successful'
    },
    errors: {
      fetchFailed: 'Failed to fetch job information',
      validationFailed: 'Form validation failed, please check your input',
      nameRequired: 'Please enter name',
      emailRequired: 'Please enter email',
      educationRequired: 'Please enter education',
      phoneRequired: 'Please enter phone',
      resumeRequired: 'Please upload resume',
      submitFailed: 'Submission failed',
      uploadFailed: 'Upload failed'
    }
  },
  cooperationManagement: {
    title: 'Cooperation Management',
    searchPlaceholder: 'Search name/company/content',
    searchButton: 'Search',
    resetButton: 'Reset',
    createdTime: 'Created Time',
    action: 'Action',
    viewDetail: 'View Detail',
    delete: 'Delete',
    batchDelete: 'Batch Delete',
    detailTitle: 'Cooperation Details',
    close: 'Close',
    deleteConfirm: 'Are you sure you want to delete this data?',
    confirmTitle: 'Confirmation',
    confirmButton: 'Confirm',
    cancelButton: 'Cancel',
    deleteSuccess: 'Deletion successful',
    batchDeleteSuccess: 'Batch deletion successful',
    batchDeleteConfirm: 'Are you sure you want to delete selected',
    items: 'items',
    selectFirst: 'Please select data to operate first',
    fetchError: 'Failed to fetch data: ',
    fetchDetailError: 'Failed to fetch details: ',
    deleteError: 'Deletion failed: '
  },
  cooperation: {
    title: 'Cooperation',
    formTitle: 'Fill Cooperation Form',
    formDescription: 'We will contact you within 1 business day',
    name: 'Name',
    namePlaceholder: 'Please enter your name',
    nameRequired: 'Please enter name',
    nameLength: 'Name length cannot exceed 50 characters',
    company: 'Company',
    companyPlaceholder: 'Please enter your company name',
    companyRequired: 'Please enter company name',
    companyLength: 'Company name length cannot exceed 100 characters',
    position: 'Position',
    positionPlaceholder: 'Please enter your position',
    positionRequired: 'Please enter position',
    positionLength: 'Position length cannot exceed 50 characters',
    phoneNumber: 'Phone Number',
    phoneNumberPlaceholder: 'Please enter your phone number',
    phoneNumberRequired: 'Please enter phone number',
    phoneNumberFormat: 'Please enter a valid phone number',
    email: 'Email',
    emailPlaceholder: 'Please enter your email',
    emailRequired: 'Please enter email',
    emailFormat: 'Please enter a valid email address',
    cooperationIntention: 'Cooperation Intention',
    cooperationIntentionPlaceholder: 'Please describe your cooperation intention in detail (at least 10 characters)',
    cooperationIntentionRequired: 'Please enter cooperation intention',
    cooperationIntentionLength: 'Cooperation intention length should be between 10 to 1000 characters',
    submitButton: 'Submit',
    resetButton: 'Reset',
    submitSuccess: 'Submitted successfully, thank you for your cooperation intention!',
    submitError: 'Submission failed: ',
    // Contact information related
    locations: {
      wenzhou: 'Wenzhou',
      china: 'China'
    },
    addressInfo: {
      suzhouAddress: 'Suzhou Industrial Park, Jiangsu Province'
    },
    map: {
      address: 'Address',
      phone: 'Phone',
      email: 'Email',
      minimize: 'Minimize',
      maximize: 'Maximize'
    },
    contact: {
      address: 'Address',
      phone: 'Phone',
      email: 'Email',
      minimize: 'Minimize'
    }
  },
  login: {
    title: 'Admin Login',
    usernameLabel: 'Username:',
    usernamePlaceholder: 'Please enter username',
    passwordLabel: 'Password:',
    passwordPlaceholder: 'Please enter password',
    loginButton: 'Login',
    errors: {
      emptyFields: 'Please enter username and password',
      loginFailed: 'Login failed',
      tryAgain: 'Login failed, please try again later'
    }
  },
  product: {
    title: 'Products Center',
    page: {
      noTemplates: 'No templates available for this product',
      createTemplate: 'Create Template',
      createDialogTitle: 'Create Product Template',
      confirmCreate: 'Confirm Creation',
      cancel: 'Cancel',
      confirm: 'Confirm',
      templateSelection: 'Template Selection',
      keywords: 'Keywords',
      keywordsPlaceholder: 'Please enter keywords',
      templateCreatedSuccess: 'Template created successfully',
      templateCreateFailed: 'Failed to create template: ',
      deleteConfirm: 'Are you sure to delete?',
      deleteConfirmTitle: 'Delete Confirmation',
      deleteSuccess: 'Delete successful',
      deleteFailed: 'Delete failed',
      deleteFailedAlert: 'Delete failed, please try again',
      updateSuccess: 'Update successful',
      updateFailed: 'Update failed',
      updateFailedAlert: 'Update failed, please try again',
        errorTitle: 'Error',
        keywordsPlaceholder: 'Please enter keywords',
        keywordsLengthLimit: 'Keywords length should be between 1 and 200 characters'
     },
    errors: {
      fetchFailed: 'Failed to fetch product list',
      productIdNotFound: 'Product ID not found',
      fetchProductInfoFailed: 'Failed to fetch product information',
      fetchProductInfoError: 'Error fetching product information',
      fetchTemplatesFailed: 'Failed to fetch product templates',
      fetchTemplatesError: 'Error fetching product templates',
      deleteTemplateFailed: 'Failed to delete template',
      createTemplateFailed: 'Failed to create template, please try again later'
    }
  },
  backgroundEditor: {
    title: 'Background Settings',
    preview: 'Preview',
    link: 'Link',
    upload: 'Local Upload',
    imagePlaceholder: 'Please select or enter image',
    videoPlaceholder: 'Please select or enter video',
    imageLinkPlaceholder: 'Please enter image link',
    videoLinkPlaceholder: 'Please enter video link',
    invalidImageUrl: 'Please enter a valid image URL',
    invalidVideoUrl: 'Please enter a valid video URL',
    failedToLoadImage: 'Failed to load image, please check if the link is correct',
    failedToLoadVideo: 'Failed to load video, please check if the link is correct',
    uploadSuccess: 'Upload successful',
    uploadFailed: 'Upload failed',
    saving: 'Saving...',
    save: 'Save',
    cancel: 'Cancel',
    linkError: 'Link error',
    waitForUpload: 'Please wait for the file upload to complete before saving',
    loadFailed: 'Failed to load content, please try again later',
    dataFormatError: 'Data format error, please check input content'
  },
  footer: {
    copyright: 'Copyright © 2025 All Rights Reserved',
    licenseNumbers: 'Ministry of Industry and Information Technology ICP: 浙ICP备2025210763号-2',
    addressTitle: 'Wenzhou, China',
    addressDetail: 'Room 339, 3rd Floor, Building 5, Wenzhou National University Science Park, No. 50 Dongfang South Road, Ouhai Economic Development Zone, Wenzhou, Zhejiang Province',
    phone: '40086-78360',
    email: '',
    city: 'WenZhou'
  },
  about: {
    company: 'About Kunbu',
    team: 'Kunbu Team',
    cases: 'Cooperation Cases'
  },
  news: {
    company: 'Company News'
  },
  navbar: {
    logo: 'KUNSTEP',
    home: 'Home',
    products: 'Products',
    technology: 'Technology',
    about: 'About Us',
    news: 'News',
    join: 'Join Us',
    contact: 'Contact Us',
    admin: 'Admin',
    login: 'Login',
    logout: 'Logout'
  },
  admin: {
    title: 'Admin Dashboard',
    menu: {
      settings: 'System Settings',
      products: 'Product Management',
      categories: 'Category Management',
      tags: 'Tag Management',
      news: 'News Management',
      jobs: 'Job Management',
      jobApplications: 'Job Application Management',
      banners: 'Banner Management',
      cooperation: 'Cooperation Management'
    },
    cooperationCase: {
      title: 'Cooperation Case Management',
      addCase: 'Add Cooperation Case',
      editCase: 'Edit Cooperation Case',
      partnerName: 'Partner Name',
      partnerNamePlaceholder: 'Please enter partner name',
      partnerNameRequired: 'Please enter partner name',
      iconUrl: 'Icon URL',
      iconUrlPlaceholder: 'Please enter icon URL',
      iconUrlRequired: 'Please enter icon URL',
      localUpload: 'Local Upload',
      orderNum: 'Order Number',
      createdAt: 'Created At',
      createSuccess: 'Cooperation case created successfully',
      updateSuccess: 'Cooperation case updated successfully',
      deleteSuccess: 'Cooperation case deleted successfully',
      deleteConfirm: 'Are you sure you want to delete this cooperation case?'
    },
    contactInfo: {
      title: 'Contact Info Management',
      addContactInfo: 'Add Contact Info',
      editContactInfo: 'Edit Contact Info',
      contactName: 'Contact Name',
      contactNameEn: 'Contact Name (EN)',
      contactNamePlaceholder: 'Please enter contact name',
      contactNameEnPlaceholder: 'Please enter contact name (EN)',
      contactNameRequired: 'Please enter contact name',
      country: 'Country',
      countryEn: 'Country (EN)',
      countryPlaceholder: 'Please enter country',
      countryEnPlaceholder: 'Please enter country (EN)',
      countryRequired: 'Please enter country',
      address: 'Address',
      addressEn: 'Address (EN)',
      addressPlaceholder: 'Please enter address',
      addressEnPlaceholder: 'Please enter address (EN)',
      addressRequired: 'Please enter address',
      phone: 'Phone',
      phonePlaceholder: 'Please enter phone',
      email: 'Email',
      emailPlaceholder: 'Please enter email',
      latitude: 'Latitude',
      latitudePlaceholder: 'Please enter latitude',
      longitude: 'Longitude',
      longitudePlaceholder: 'Please enter longitude',
      backupField1: 'Backup Field 1',
      backupField1Placeholder: 'Please enter backup field 1',
      backupField2: 'Backup Field 2',
      backupField2Placeholder: 'Please enter backup field 2',
      backupField3: 'Backup Field 3',
      backupField3Placeholder: 'Please enter backup field 3',
      sortOrder: 'Sort Order',
      createdAt: 'Created At',
      createSuccess: 'Contact info created successfully',
      updateSuccess: 'Contact info updated successfully',
      deleteSuccess: 'Contact info deleted successfully',
      deleteConfirm: 'Are you sure you want to delete this contact info?',
      batchDeleteSuccess: 'Batch delete contact info successfully',
      batchDeleteConfirm: 'Are you sure you want to delete selected contact info?',
      selectItemsFirst: 'Please select items to operate first',
      fetchFailed: 'Failed to fetch contact info',
      submitFailed: 'Submit failed'
    },
    page: {
      settings: 'System Settings',
      products: 'Product Management',
      categories: 'Category Management',
      tags: 'Tag Management',
      news: 'News Management',
      jobs: 'Job Management',
      jobApplications: 'Job Application Management',
      cooperation: 'Cooperation Management',
      banners: 'Banner Management',
      cooperationCaseManagement: 'Cooperation Case Management',
      contactInfoManagement: 'Contact Info Management'
    },
    logout: 'Logout',
    confirmLogout: 'Confirm Logout',
    search: 'Search',
    reset: 'Reset',
    submit: 'Submit',
    cancel: 'Cancel',
    ok: 'OK',
    confirm: 'Confirm',
    all: 'All',
    actions: 'Actions',
    upload: {
      failed: 'Upload failed',
      productSuccess: 'Upload successful and automatically filled into main image field',
      newsSuccess: 'Upload successful and automatically filled into cover image field'
    },
    queryFailed: 'Query failed',
    error: {
      fetchFailed: 'Failed to fetch data',
      saveFailed: 'Failed to save',
      deleteFailed: 'Failed to delete',
      updateFailed: 'Failed to update',
      queryFailed: 'Query failed'
    },

    products: {
      title: 'Product Management',
      addProduct: 'Add Product',
      editProduct: 'Edit Product',
      name: 'Product Name',
      namePlaceholder: 'Please enter product name',
      nameRequired: 'Please enter product name',
      nameEn: 'Product English Name',
      nameEnPlaceholder: 'Please enter product English name',
      category: 'Category',
      selectCategory: 'Please select category',
      categoryRequired: 'Please select product category',
      tags: 'Tags',
      selectTags: 'Please select tags',
      price: 'Price',
      priceRequired: 'Please enter price',
      stock: 'Stock',
      stockRequired: 'Please enter stock',
      status: 'Status',
      description: 'Description',
      descriptionPlaceholder: 'Please enter product description',
      mainImage: 'Main Image',
      mainImageTip: 'Please upload product main image',
      mainImageRequired: 'Please upload product main image',
      createSuccess: 'Product created successfully',
      updateSuccess: 'Product updated successfully',
      deleteSuccess: 'Product deleted successfully',
      deleteConfirm: 'Are you sure to delete this product?'
    },
    categories: {
      title: 'Category Management',
      addCategory: 'Add Category',
      editCategory: 'Edit Category',
      name: 'Category Name',
      namePlaceholder: 'Please enter category name',
      nameRequired: 'Please enter category name',
      description: 'Description',
      descriptionPlaceholder: 'Please enter category description',
      createdAt: 'Created At',
      createSuccess: 'Category created successfully',
      updateSuccess: 'Category updated successfully',
      deleteSuccess: 'Category deleted successfully',
      deleteConfirm: 'Are you sure to delete this category?'
    },
    tags: {
      title: 'Tag Management',
      addTag: 'Add Tag',
      editTag: 'Edit Tag',
      name: 'Tag Name',
      namePlaceholder: 'Please enter tag name',
      nameRequired: 'Please enter tag name',
      color: 'Tag Color',
      colorRequired: 'Please select tag color',
      createdAt: 'Created At',
      createSuccess: 'Tag created successfully',
      updateSuccess: 'Tag updated successfully',
      deleteSuccess: 'Tag deleted successfully',
      deleteConfirm: 'Are you sure to delete this tag?'
    },
    news: {
      title: 'News Management',
      addNews: 'Add News',
      editNews: 'Edit News',
      publishTimePlaceholder: 'Please select publish time',
      title: 'News Title',
      titlePlaceholder: 'Please enter news title',
      titleRequired: 'Please enter news title',
      summary: 'News Summary',
      summaryPlaceholder: 'Please enter news summary',
      summaryRequired: 'Please enter news summary',
      coverImage: 'News Cover',
      coverImageTip: 'Please upload news cover image',
      coverImageRequired: 'Please upload news cover image',
      publishTime: 'Publish Time',
      publishTimeRequired: 'Please select publish time',
      linkUrl: 'Link URL',
      linkUrlPlaceholder: 'Please enter news link URL',
      uploadSuccess: 'Upload successful',
      uploadFailed: 'Upload failed',
      createSuccess: 'News created successfully',
      updateSuccess: 'News updated successfully',
      deleteSuccess: 'News deleted successfully',
      deleteConfirm: 'Are you sure to delete this news?'
    },
    banner: {
      title: 'Banner Management',
      addBanner: 'Add Banner',
      editBanner: 'Edit Banner',
      titlePlaceholder: 'Please enter banner title',
      titleRequired: 'Please enter banner title',
      bannerUrl: 'Banner Image',
      bannerImageTip: 'Please upload banner image',
      bannerUrlRequired: 'Please upload banner image',
      bannerUrlPlaceholder: 'Please enter banner image URL',
      linkUrl: 'Redirect Link',
      linkUrlPlaceholder: 'Please enter redirect link (optional)',
      sortOrder: 'Sort Order',
      isEnabled: 'Is Enabled',
      statusUpdateSuccess: 'Status updated successfully',
      createdAt: 'Created At',
      createSuccess: 'Banner created successfully',
      updateSuccess: 'Banner updated successfully',
      deleteSuccess: 'Banner deleted successfully',
      deleteConfirm: 'Are you sure you want to delete this banner?',
      localUpload: 'Local Upload',
      bannerImageFileList: 'Banner image file list',
      errors: {
          fetchFailed: 'Failed to fetch Banner list'
        }
    },
    jobs: {
      title: 'Job Management',
      addJob: 'Add Job',
      editJob: 'Edit Job',
      jobName: 'Job Title',
      titlePlaceholder: 'Please enter job title',
      titleRequired: 'Please enter job title',
      location: 'Location',
      locationPlaceholder: 'Please enter location',
      locationRequired: 'Please enter location',
      description: 'Description',
      descriptionPlaceholder: 'Please enter job description',
      descriptionRequired: 'Please enter job description',
      createSuccess: 'Job created successfully',
      updateSuccess: 'Job updated successfully',
      deleteSuccess: 'Job deleted successfully',
      deleteConfirm: 'Are you sure to delete this job?',
      searchPlaceholder: 'Search jobs',
      viewDetails: 'View details',
      loading: 'Loading...',
      empty: 'No job data available',
      jobDetails: 'Job Details',
      locationLabel: 'Location: ',
      publishTimeLabel: 'Publish Time: ',
      uploadTip: 'Click or drag file to upload',
      resumeFormatTip: 'Supports .pdf, .doc, .docx formats',
      selectAvailableDate: 'Select available date',
      selfIntroductionPlaceholder: 'Please introduce yourself',
      applyForJob: 'Apply for this job',
      namePlaceholder: 'Please enter your name',
      emailPlaceholder: 'Please enter your email',
      phonePlaceholder: 'Please enter your phone',
      educationPlaceholder: 'Please enter your education',
      autoSubmitting: 'Auto-submitting...',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      education: 'Education',
      resume: 'Resume',
      availableDate: 'Available Date',
      selfIntroduction: 'Self Introduction',
      errors: {
        nameRequired: 'Please enter your name',
        emailRequired: 'Please enter your email',
        emailInvalid: 'Please enter a valid email address',
        educationRequired: 'Please enter your education',
        phoneRequired: 'Please enter your phone',
        phoneInvalid: 'Please enter a valid phone number',
        resumeRequired: 'Please upload your resume',
        validationFailed: 'Validation failed, please check and complete the information',
        fetchListFailed: 'Failed to fetch job list',
        fetchDetailFailed: 'Failed to fetch job details',
        submitFailed: 'Job application submission failed, please try again later'
       },
      success: {
        submitting: 'Submitting application...',
        submitSuccess: 'Job application submitted successfully!',
        uploadSuccess: 'Upload successful!',
        uploadFailed: 'Upload failed!'
      }
    },
    jobApplications: {
      title: 'Job Application Management',
      applicationId: 'Application ID',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      education: 'Education',
      jobTitle: 'Job Title',
      selectJob: 'Select Job',
      status: 'Status',
      applyTime: 'Apply Time',
      resume: 'Resume',
      coverLetter: 'Cover Letter',
      availableDate: 'Available Date',
      selfIntroduction: 'Self Introduction',
      viewResume: 'View Resume',
      viewCoverLetter: 'View Cover Letter',
      download: 'Download',
      actionRequired: 'Action Required',
      newTabBlocked: 'The browser blocked opening a new tab. Would you like to download the file?',
      fileTypeNotSupported: 'This file type cannot be opened directly in the browser. Would you like to download it?',
      viewDetails: 'Details',
      updateStatus: 'Update Status',
      delete: 'Delete',
      deleteConfirm: 'Are you sure to delete this job application?',
      statusUpdateSuccess: 'Status updated successfully',
      deleteSuccess: 'Deleted successfully',
      searchPlaceholder: 'Search by name, email or phone',
      search: 'Search',
      reset: 'Reset',
      submit: 'Submit',
      confirm: 'Confirm',
      cancel: 'Cancel',
      statusOptions: {
        pending: 'Pending',
        reviewed: 'Reviewed',
        interviewed: 'Interviewed',
        approved: 'Approved',
        rejected: 'Rejected'
      },
      details: 'Job Application Details',
      close: 'Close',
      selectStatus: 'Please select status',
      statusRequired: 'Please select status',
      exportSelectedData: 'Export Selected Data',
      exportAllData: 'Export All Data',
      exportData: 'Export Data',
      readStatus: 'Read Status',
      read: 'Read',
      unread: 'Unread',
      error: {
        fetchFailed: 'Failed to fetch data',
        updateFailed: 'Failed to update',
        deleteFailed: 'Failed to delete'
      }
    }
  },
  language: {
    zh: '中文',
    en: 'English'
  },
  news: {
    title: 'News',
    moreNews: 'More News',
    loading: 'Loading...',
    empty: 'No news available',
    publishTime: 'Publish Time',
    company: 'Company News'
  },
  jobs: {
    title: 'Join Us',
    searchPlaceholder: 'Search Jobs',
    jobList: 'Job List',
    viewDetails: 'View Details →',
    loading: 'Loading...',
    loadedAll: 'All jobs have been displayed',
    loadMore: 'Load More',
    empty: 'No job information available',
    jobDetails: 'Job Details',
    location: 'Location: ',
    publishTime: 'Publish Time: ',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    education: 'Education',
    resume: 'Resume',
    uploadTip: 'Drag file here or click to upload',
    resumeFormatTip: 'Please upload resume in PDF or Word format',
    availableDate: 'Available Date',
    selectAvailableDate: 'Select Available Date',
    selfIntroduction: 'Self Introduction',
    selfIntroductionPlaceholder: 'Please briefly introduce yourself and why you are suitable for this position',
    autoSubmitting: 'The system is automatically processing your application, please wait...',
    applyForJob: 'Apply for Job',
    form: {
      namePlaceholder: 'Please enter your name',
      emailPlaceholder: 'Please enter your email',
      phonePlaceholder: 'Please enter your phone number',
      educationPlaceholder: 'Please enter your education background',
      submitting: 'Submitting application...'
    },
    errors: {
      fetchFailed: 'Failed to fetch job list',
      validationFailed: 'Validation failed, please check and complete the information',
      nameRequired: 'Please enter your name',
      emailRequired: 'Please enter your email',
      emailInvalid: 'Please enter a valid email address',
      educationRequired: 'Please enter your education background',
      phoneRequired: 'Please enter your phone number',
      phoneInvalid: 'Please enter a valid phone number',
      resumeRequired: 'Please upload your resume',
      submitFailed: 'Job application submission failed, please try again later',
      uploadFailed: 'Upload failed!'
    },
    success: {
      submitSuccess: 'Job application submitted successfully!',
      uploadSuccess: 'Upload successful!'
    }
  },
  demo: {
    baseComTitle: 'BaseCom Component Examples',
    baseComExample1: 'Example 1: Using Slot',
    baseComExample2: 'Example 2: Using content Property',
    baseComExample3: 'Example 3: Non-editable State',
    baseComSlotContent: 'This content is passed via slot',
    baseComPropContent: 'This content is passed via content property',
    baseComNonEditableContent: 'This is non-editable content',
    textComTitle: 'TextCom Component Examples',
    textComExample1: 'Example 1: Default Text Style',
    textComExample2: 'Example 2: Custom Font Size and Color',
    textComExample3: 'Example 3: Using Slot for Custom Content',
    textComDefaultContent: 'This is text with default style',
    textComCustomContent: 'This is text with custom style',
    textComSlotContent: 'This is custom content passed via slot',
    containerComTitle: 'ContainerCom Component Examples',
    containerComExample1: 'Example 1: Using Image Background',
    containerComExample2: 'Example 2: Using Static Background Color',
    containerComImageContent: 'Image Background Container Example',
    containerComStaticContent: 'Static Background Container Example (Video not available due to CORS)'  
  },
  // Technology related content
  technology: {
    title: 'TECHNICAL FEATURES',
    feature1: {
      title: 'Precise Gait Monitoring',
      desc: 'Multi-sensor signal fusion, real-time statistics of step length, step speed, joint angles, precise identification of walking posture, muscle abnormality monitoring triggers target muscle action.'
    },
    feature2: {
      title: 'Stable Dynamic Force Control',
      desc: 'Precise control system, feedforward feedback and other control forces, allowing the system to still achieve precise force control in complex dynamic environments, ensuring exercise intensity and effectiveness.'
    },
    feature3: {
      title: 'Intelligent Assistance Optimization',
      desc: 'In continuous learning, the device iteratively optimizes the assistance method from gait feedback, efficiently pushing the patient\'s real gait, personalized experience, and precise effect to the extreme.'
    },
    feature4: {
      title: 'Walking Data Visualization',
      desc: 'High detection and recording of sensors, allowing data visualization of patient walking posture, thus enabling tracking, analysis and repeated comparison of walking status at different periods.'
    }
  },
  messages: {
    editClick: 'Edit button clicked!',
    editingText: 'Editing text...',
    editingContainer: 'Editing container...',
    languageSwitched: 'Language switched to {language}',
    saveSuccess: 'Save successful',
    saveFailed: 'Save failed'
  },
  contactFloat: {
    contactPhone: 'Contact Phone',
    wechatQRCode: 'Add WeChat Support',
    qrCodePlaceholder: 'WeChat QR Code',
    onlineContact: 'Contact',
    onlineContact2: 'Online Contact',
    phoneContact: 'Phone',
    phoneContact2: 'Phone Contact',
    wechatConsult: 'WeChat',
    wechatConsult2: 'WeChat Consult',
    scanToAdd: 'Scan to Add',
    kunbuRobot: 'Kunbu Robot'
  }
}